import { formatDate, formatNumber } from 'devextreme/localization';
import { useContext, } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, Field } from '../../../../layouts';
import { OrderStatus } from '../../../../types/enums';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function RetailOrderInformationCard() {

	const { order } = useContext(RetailOrderContext);
	let [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	return (
		<>
			<Card
				header={'Retail Order Information'}
				className="retail-order-info-card field-label-35"
			>
				<Field label={'Retail Order #'} showCopyToClipboard={true} >{order.details.roNumber}</Field>
				<Field label={'RO Date'} >{formatDate(new Date(order.details.roDate), 'shortDate')}</Field>
				<Field label={'Status'} >{order.details.orderStatus}</Field>
				<Field label={'Hold Reason'} visible={order.details.orderStatusID === OrderStatus.Hold}>{order.details.holdReason}</Field>
				{
					order.details.IME &&
					<Field label={'IME Status'} >{order.details.imeStatus}</Field>
				}
				{
					order.details.IMS &&
					<Field label={'IMS Status'} >{order.details.imsJobStatus + ' / ' + order.details.imsPOStatus}</Field>
				}
				<Field label={'Total'} >{formatNumber(order.details.amount, { type: 'currency', precision: 2 })}</Field>
				<Field label={'Project #'} showCopyToClipboard={true} >{order.details.projectNumber}</Field>
				<Field label={'Parent RO #'} visible={!!order.details.linkedROID && !!order.details.linkedRONumber}>
					<Link to={'/cfi/retail-order/' + order.details.linkedROID + (!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
						{order.details.linkedRONumber}
					</Link>
					&nbsp;({formatNumber(order.details.linkedROAmount, { type: 'currency', precision: 2 })})
				</Field>
				{
					order.details?.addons && order.details?.addons.length > 0 &&
					<Field label={"Related RO's"}>
						{
							order.details?.addons.map((addon) => {
								return (
									<span key={addon.retailOrderID}>
										{
											addon.assignedCompanyID === order.details.assignedCompanyID ?
												<Link to={'/cfi/retail-order/' + addon.retailOrderID + (!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
													{addon.roNumber}
												</Link>
												:
												<span>{addon.roNumber}</span>
										}

										&nbsp;({formatNumber(addon.amount, { type: 'currency', precision: 2 })})
									</span>
								)
							})
						}
					</Field>
				}
			</Card>
		</>
	);
}
